module.exports = __webpack_public_path__ + "img/tomazov.a8132c92.png";